module.exports = __webpack_public_path__ + "img/Search.e3f25c83.png";